const AUTH_ERROR_MESSAGES = Object.freeze({
	access_denied: "Sign-in was cancelled. You can try again or continue with your work email.",
	account_conflict: "An account already uses that email. Log in with your email code before linking this provider.",
	account_not_found: "No Tiga account is linked to that provider. Log in with your email code before linking it.",
	google_workspace_required: "Use a Google Workspace account to continue. Personal Gmail accounts aren’t supported.",
	invalid_identity: "We couldn’t verify that work account. Please try again or use your work email.",
	microsoft_organization_required: "Use a Microsoft work or school account to continue. Personal Microsoft accounts aren’t supported.",
	provider_error: "We couldn’t complete provider sign-in. Please try again or use your work email.",
	provider_unavailable: "That sign-in provider is temporarily unavailable. Please try again or use your work email.",
	session_expired: "Your sign-in session expired. Please try again.",
	signup_unavailable: "Trial signups are currently full. Please check back later."
})

function cleanText (value, limit) {
	return Array.from(String(value || ""))
		.filter(character => character.charCodeAt(0) > 31 && character.charCodeAt(0) !== 127)
		.join("")
		.trim()
		.slice(0, limit)
}

export function authErrorMessage (code) {
	const normalizedCode = cleanText(code, 80)
	return Object.hasOwn(AUTH_ERROR_MESSAGES, normalizedCode) ? AUTH_ERROR_MESSAGES[normalizedCode] : ""
}

export function readSignupBootstrap (root, search = window.location.search) {
	const params = new URLSearchParams(search)
	const errorCode = root?.dataset.signupErrorCode || params.get("auth_error") || params.get("oidc_error")

	return {
		initialStep: root?.dataset.signupStep,
		initialEmail: cleanText(root?.dataset.signupEmail, 254),
		initialFirstName: cleanText(root?.dataset.signupFirstName, 255),
		initialLastName: cleanText(root?.dataset.signupLastName, 255),
		initialError: authErrorMessage(errorCode),
		googleEnabled: root?.dataset.signupGoogleEnabled === "true",
		microsoftEnabled: root?.dataset.signupMicrosoftEnabled === "true"
	}
}
